import { useCallback } from 'react';
import { NotificationService } from '../services/notification.service';

export const useNotifications = () => {
  const showSuccess = useCallback((message: string, title?: string) => {
    NotificationService.success(message, title);
  }, []);

  const showError = useCallback((message: string, title?: string) => {
    NotificationService.error(message, title);
  }, []);

  const showWarning = useCallback((message: string, title?: string) => {
    NotificationService.warning(message, title);
  }, []);

  const showInfo = useCallback((message: string, title?: string) => {
    NotificationService.info(message, title);
  }, []);

  const showLoading = useCallback((message: string) => {
    NotificationService.loading(message);
  }, []);





  return {
    showSuccess,
    showError,
    showWarning,
    showInfo,
    showLoading,
  };
}; 